import { connect } from 'react-redux';
import Landing from './Landing';


const mapStateToProps = state => ({
    authToken: state.auth.authToken,
});


export default connect(mapStateToProps)(Landing);



// WEBPACK FOOTER //
// ./src/containers/Landing/index.js